import { AsyncThunk } from '@reduxjs/toolkit';

import { withMandant } from '../../../../../shared/thunks/with-mandant/with-mandant.thunk';
import { axiosInstance } from '../../../../shared/api/axios-instance';
import { createPathParams } from '../../../../shared/utils/create-path-params/create-path-params.util';
import { Endpoints } from '../../../../shared/utils/endpoints-file.utils';

export const deleteReview: AsyncThunk<
  void,
  number,
  Record<string, unknown>
> = withMandant<number, void>(
  Endpoints.REVIEW_BY_ID,
  'reviews/delete-review',
  async ({ args, endpoint }) => {
    const url = createPathParams<'id'>(endpoint, { id: args });

    await axiosInstance.delete(url);
  }
);
